import React from "react";

export default function About() {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>About Us</h1>
      <p>
        Hi! I am Tianbo Yu, the developer of this web application. Nice to meet you here!
      </p>
    </section>
  );
}
